import { SubscriptionBase } from '../subscription';

export class InsuranceBase extends SubscriptionBase {}
